const translations = {
    applications: 'Applications',
    editUser: 'Edit User',
    linkedEntities: 'Linked Entities'
};

export default translations;
